import styled from 'styled-components';

const CustomerToggleButton = styled.button.attrs({ type: 'button' })`
   background-color: transparent;
   border: 1px solid ${({ theme }) => theme.primaryBlueDark};
   border-radius: 4px;
   padding: 4px 6px;
   font-weight: 600;
   min-width: 128px;
   &:hover {
      color: ${({ theme }) => theme.primaryWhite};
      background-color: ${({ theme }) => theme.primaryBlueDark};
      cursor: pointer;
   }

   @media only screen and (max-width: 590px) {
      font-size: 10px;
   }
`;

export default CustomerToggleButton;
